import React from 'react'

const Hospital = ({
  name,
  address,
  long,
  lat,
  type,
  distance,
  edResuscitation,
  edResuscitationTraffic,
  edEmergency,
  edEmergencyTraffic,
  edUrgent,
  edUrgentTraffic,
  edSemiUrgent,
  edSemiUrgentTraffic,
  edNonUrgent,
  edNonUrgentTraffic,
  urgentElectiveSurgery,
  urgentElectiveSurgeryTraffic,
  semiUrgentElectiveSurgery,
  semiUrgentElectiveTraffic,
  nonUrgentElectiveSurgery,
  nonUrgentElectiveSurgeryTraffic
}) => {

  const clipStyle = {
    marginBottom: '-24px',
    zIndex: '30',
  }

  function checkFace(traffic) {
    if (traffic === "Red") {
      return <svg className="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#E53935" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 9.05V8.95" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 9.05V8.95" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 16C15.5 14.5 14.21 13 12 13C9.79 13 8.5 14.5 8 16" stroke="#212121" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    } else if (traffic === "Amber") {
      return <svg className="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#FDD835" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 9.05V8.95" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 9.05V8.95" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 14H16" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
      </svg>
    } else if (traffic === "Grey" || traffic === "") {
      return <svg className="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="black" stroke-width="2" />
        <path d="M10 8.484C10.5 7.494 11 7 12 7C13.246 7 14 7.989 14 8.978C14 9.967 13.5 10.461 12 11.451V13M12 16.5V17" stroke="black" stroke-width="2" stroke-linecap="round" />
      </svg>

    } else {
      return <svg className="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#43A047" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 9.05V8.95" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 9.05V8.95" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 14C15.5 15.5 14.21 17 12 17C9.79 17 8.5 15.5 8 14" stroke="#212121" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    }
  }
  return (
    <div className='flex flex-col items-center'>
      <svg width="194" height="59" viewBox="0 0 194 59" fill="none" xmlns="http://www.w3.org/2000/svg" class="" style={clipStyle}><mask id="path-1-inside-1_1076_577" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M48 0C42.4772 0 38 4.47715 38 10V26H0V59H194V26H156V10C156 4.47715 151.523 0 146 0H48Z"></path></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M48 0C42.4772 0 38 4.47715 38 10V26H0V59H194V26H156V10C156 4.47715 151.523 0 146 0H48Z" fill="#C4C4C4" fill-opacity="0.2"></path><path d="M38 26V27H39V26H38ZM0 26V25H-1V26H0ZM0 59H-1V60H0V59ZM194 59V60H195V59H194ZM194 26H195V25H194V26ZM156 26H155V27H156V26ZM39 10C39 5.02944 43.0294 1 48 1V-1C41.9249 -1 37 3.92487 37 10H39ZM39 26V10H37V26H39ZM0 27H38V25H0V27ZM1 59V26H-1V59H1ZM194 58H0V60H194V58ZM193 26V59H195V26H193ZM156 27H194V25H156V27ZM155 10V26H157V10H155ZM146 1C150.971 1 155 5.02944 155 10H157C157 3.92487 152.075 -1 146 -1V1ZM48 1H146V-1H48V1Z" fill="black" fill-opacity="0.15" mask="url(#path-1-inside-1_1076_577)"></path></svg>
      <div className='bg-gray-100 rounded-3xl p-4 space-y-3 text-left w-full'>
        {distance && <p>~{distance} km</p>}
        <p>{type}</p>
        <p className='text-xl font-medium'>{name}</p>
        <p></p>
        <div className="flex w-full justify-center space-x-4">
          <div className='text-left space-y-2 w-full'>
            <p className='font-semibold'>Emergency department</p>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(edResuscitationTraffic)}</p>
                <p>{edResuscitation}%</p>
              </div>
              <p>- Resuscitation</p>
            </div>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(edEmergencyTraffic)}</p>
                <p>{edEmergency}%</p>
              </div>
              <p>- Emergency</p>
            </div>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(edUrgentTraffic)}</p>
                <p>{edUrgent}%</p>
              </div>
              <p>- Urgent</p>
            </div>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(edSemiUrgentTraffic)}</p>
                <p>{edSemiUrgent}%</p>
              </div>
              <p>- Semi-urgent</p>
            </div>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(edNonUrgentTraffic)}</p>
                <p>{edNonUrgent}%</p>
              </div>
              <p>- Non-urgent</p>
            </div>
          </div>
          <div className='text-left space-y-2 w-full'>
            <p className='font-semibold'>Elective surgery</p>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(urgentElectiveSurgeryTraffic)}</p>
                <p>{urgentElectiveSurgery}%</p>
              </div>
              <p>- Urgent</p>
            </div>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(semiUrgentElectiveTraffic)}</p>
                <p>{semiUrgentElectiveSurgery}%</p>
              </div>
              <p>- Semi-urgent</p>
            </div>
            <div className='w-full flex space-x-1'>
              <div className='flex space-x-1'>
                <p>{checkFace(nonUrgentElectiveSurgeryTraffic)}</p>
                <p>{nonUrgentElectiveSurgery}%</p>
              </div>
              <p>- Non-urgent</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hospital